import React from 'react';
import { GoogleLogin } from '@react-oauth/google';

const GoogleLoginButton = ({ handleSuccess }) => {
    const handleGoogleLoginError = () => {
        console.error('Google login failed');
    };

    return (
        <GoogleLogin
            onSuccess={handleSuccess}
            onError={handleGoogleLoginError}
            text="signin_with"
            theme="outline"
            size="medium"
        />
    );
};

export default GoogleLoginButton;




